/**
 * Ant Design breakpoint helper — treat below `md` (~768px) as narrow/mobile.
 * US-900+ mobile-responsive track; matches US-307 case-list breakpoint.
 */
import { Grid } from "antd";

export function useNarrowViewport(breakpoint: "sm" | "md" | "lg" = "md"): boolean {
  const screens = Grid.useBreakpoint();
  // Until first measure, screens[bp] is undefined — treat as desktop to avoid flash of mobile chrome in SSR-less CRA.
  if (screens[breakpoint] === undefined) return false;
  return !screens[breakpoint];
}
